// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app[data-v-3777b22f]{position:relative}.historicalPrices[data-v-3777b22f]{position:relative;width:100%}.chart-container[data-v-3777b22f]{max-height:500px}.chart-container>div[data-v-3777b22f]{position:relative;width:100%}.loadingPrices[data-v-3777b22f]{position:absolute;top:0;left:0;transform:translateZ(0);background-color:rgba(0,0,0,.7);width:100%;height:100%;text-align:center;padding:100px 0;color:#fff;z-index:100}", ""]);
// Exports
module.exports = exports;
